import Segmentable from './Segmentable';
import { AudioSegment, BaseAudioSegmentPlayer } from './types';
import WebAudioPlayer from './WebAudioPlayer';

/**
 * A variant of the AudioPlayer which satisfies the BaseAudioPlayer contract by
 * playing a segment from a larger audio file.  After an instance is created with
 * a specified Segment, the outside world doesn't know that its not playing an entire
 * audio file; in other words, the outside world refers to `segment.startSec` as `0`
 * and `segment.endSec` as `player.duration`.
 */
const AudioSegmentPlayer = Segmentable(
  class AudioSegmentPlayer
    extends WebAudioPlayer
    implements BaseAudioSegmentPlayer {
    public segment: AudioSegment;

    constructor(
      element: HTMLMediaElement,
      segment: AudioSegment,
      ctx?: AudioContext,
    ) {
      super(element, ctx);
      this.segment = segment;
    }
  },
);

export default AudioSegmentPlayer;
